<mat-icon class="close-icon" mat-dialog-close>close</mat-icon>
<h4 mat-dialog-title>Delete Account</h4>
<mat-dialog-content>
  <p>
    Are you sure you would like to delete your ProjectZen account? We would be
    sad to see you go!
  </p>
  <p>
    Keep in mind that items currently shared with other users will continue to
    be available to those users even after this account's deletion. To remove
    those items as well, either unshare or delete them.
  </p>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-flat-button cdkFocusInitial (click)="deleteUserAccount()">
    Delete Account
  </button>
  <button mat-stroked-button cdkFocusInitial mat-dialog-close>Cancel</button>
</mat-dialog-actions>